import styled from 'styled-components';
import { BodyOrText, Headlines } from 'gocclr-shared-ui/dist/styles/styled/typography';
import { accountsMedia } from '../../styles/bootstrap-breakpoints';

export const H1 = styled.h1`
    ${Headlines}
    font-size: 1.625rem;
    color: ${props => props.theme.colors.text.primary};
    margin: 10px 0 0 0;
    line-height: 1;

    ${accountsMedia.greaterThan('Medium')`
        font-size: 1.5rem;
    `}
`;

export const H2 = styled.h2`
    ${BodyOrText}
    color: ${props => props.theme.colors.text.primary};
    font-size: 1.3rem;
    font-weight: 100;
    margin: 10px 0 0 0;
    line-height: 1;
`;

export const H3 = styled.h3`
    ${BodyOrText}
    font-size: 1rem;
    font-weight: 800;
    color: ${props => props.theme.colors.text.primary};
    margin: 10px 0 0 0;
    line-height: 1;
`;